<!-- Copyright (c) 2023 VMware, Inc. All rights reserved. VMware Confidential -->
<div [@addTask] [@focus]="focused"
     *ngIf="!removeTaskTriggered"
     class="task-container"
     [ngClass]="{
            'focused': focused,
            'hidden': hidden
        }"
     [style.display]="showProgressBesideTitle ? 'flex' : 'block'">

    <div class="title"
         [class.push-close-button]="pushCloseButton">
        <button class="btn-back"
                *ngIf="showBackButton"
                (click)="back($event)">
            <cds-icon shape="arrow"
                      direction="left"
                      size="18"></cds-icon>
        </button>

        <!-- success icon -->
        <svg *ngIf="showCheckIcon" class="icon" width="36" height="36" viewBox="0 0 36 36">
            <path id="success-icon-outline" d="M18,7A11,11,0,1,1,7,18,11,11,0,0,1,18,7"/>
            <path [@successIconLine] id="success-icon-check" d="M12.2,18.2l4.1,4.1L23.7,15"/>
        </svg>

        <!-- failure icon -->
        <svg *ngIf="showExclamationIcon" class="icon" width="36" height="36" viewBox="0 0 36 36">
            <path id="error-icon-outline" d="M18,7A11,11,0,1,1,7,18,11,11,0,0,1,18,7"/>
            <path [@errorIconLine] id="error-icon-line" d="M18,12.8v5.9"/>
            <circle [@errorIconDot] id="error-icon-dot" cx="18" cy="23" r="1.4"/>
        </svg>


        <ng-content *ngIf="!cancelConfirm" select="h4.title"></ng-content>
        <ng-content *ngIf="cancelConfirm" select="h4.cancel-title"></ng-content>

        <button *ngIf="showClearButton"
                class="clear-btn"
                [class.push-close-button]="pushCloseButton"
                (click)="clear()">
            <cds-icon
                shape="times"
                size="18"
                solid>
            </cds-icon>
        </button>
    </div>

    <div class="progress"
         *ngIf="!cancelConfirm && state === VmwTaskState.IN_PROGRESS"
         [ngClass]="{
            'loop': showIndeterminateProgress,
            'labeled': showProgressPercentage
        }"
         [style.marginLeft]="showProgressBesideTitle ? '12px' : '0px'">
        <progress max="100"
                  value="{{progress}}"></progress>
        <span *ngIf="showProgressPercentage">{{progress}} %</span>
    </div>

    <ng-container *ngIf="canShowDescription">
        <ng-content *ngIf="!cancelConfirm" select=".description"></ng-content>
        <ng-content *ngIf="cancelConfirm" select=".cancel-description"></ng-content>
    </ng-container>

<!-- TODO: Remove TaskPanel customization
    <div class="button-container" *ngIf="!summarized">
-->
    <div class="button-container">
        <div [@cancelTask] *ngIf="!cancelConfirm">
            <button class="dismiss"
                (click)="dismiss()">{{'console.task.panel.button.dismiss' | vtranslate}}</button>
            <button *ngIf="customActionText"
                    (click)="customClicked()">{{customActionText}}</button>
            <button *ngIf="cancelable"
                    class="cancel"
                (click)="cancelConfirm = true">{{'console.task.panel.button.cancel' | vtranslate}}</button>
        </div>

        <div [@cancelTask] *ngIf="cancelConfirm">
            <button class="btn cancel-confirm-no btn-sm btn-outline"
                    (click)="cancelConfirm = false">{{'console.task.panel.button.no' | vtranslate}}
            </button>
            <button class="btn btn-warning btn-sm cancel-confirm-yes"
                    (click)="cancel()">{{'console.task.panel.button.cancel.confirm' | vtranslate}}
            </button>
        </div>
    </div>
</div>
